var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isReady)?_c('div',{staticClass:"dashboard"},[_c('UpperDashboard'),_c('LowerDashboard')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }